import { Component } from 'react'
import styled from 'styled-components'
import { displayInAziendaValuta } from '../Library/Tools/CurrencyConverter'

const DisplayWrapper = styled.span`
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.01em;
  white-space: nowrap;
  color: ${props => props.theme?.colors?.text?.primary || '#000'};

  ${props => props.$bold && `
    font-weight: 600;
  `}

  ${props => props.$muted && `
    color: ${props.theme?.colors?.text?.secondary || '#666'};
  `}

  ${props => props.$large && `
    font-size: 1.125rem;
  `}

  ${props => props.$small && `
    font-size: 0.875rem;
  `}
`

/**
 * CurrencyDisplay - Mostra un prezzo nella valuta dell'azienda
 *
 * Converte automaticamente da EUR (valuta backend) alla valuta dell'azienda.
 * Se azienda non è fornita o non ha valuta, usa EUR come default.
 *
 * @example
 * // Mostra 100 EUR nella valuta dell'azienda
 * <CurrencyDisplay amountEUR={100} azienda={currentAzienda} />
 *
 * // Se azienda.valuta = 'XOF' → "65.596 CFA"
 * // Se azienda.valuta = 'EUR' → "100,00 €"
 *
 * @example
 * // Con stili personalizzati
 * <CurrencyDisplay
 *   amountEUR={1500}
 *   azienda={azienda}
 *   bold
 *   large
 * />
 */
export default class CurrencyDisplay extends Component {
  constructor (props) {
    super(props)
    this.state = {
      displayValue: 'Caricamento...',
      loading: true
    }
  }

  componentDidMount () {
    this.updateDisplay()
  }

  componentDidUpdate (prevProps) {
    // Aggiorna se cambia l'importo o l'azienda
    if (
      prevProps.amountEUR !== this.props.amountEUR ||
      prevProps.azienda?._id !== this.props.azienda?._id ||
      prevProps.azienda?.valuta !== this.props.azienda?.valuta
    ) {
      this.updateDisplay()
    }
  }

  updateDisplay () {
    const { amountEUR, azienda, fallbackText = 'N/A' } = this.props

    // Se non c'è importo, mostra fallback
    if (amountEUR === null || amountEUR === undefined || isNaN(amountEUR)) {
      this.setState({
        displayValue: fallbackText,
        loading: false
      })
      return
    }

    try {
      // Converti e formatta (ora sincrono)
      const formatted = displayInAziendaValuta(amountEUR, azienda)

      this.setState({
        displayValue: formatted,
        loading: false
      })
    } catch (error) {
      console.error('❌ Errore nella conversione valuta per display:', error)
      this.setState({
        displayValue: fallbackText,
        loading: false
      })
    }
  }

  render () {
    const {
      amountEUR,
      azienda,
      fallbackText,
      bold,
      muted,
      large,
      small,
      className,
      style,
      loading: propsLoading,
      ...otherProps
    } = this.props

    const { displayValue, loading } = this.state

    // Se è in loading e c'è un testo di loading custom, usalo
    const showLoading = loading && propsLoading !== false
    const text = showLoading && propsLoading ? propsLoading : displayValue

    return (
      <DisplayWrapper
        $bold={bold}
        $muted={muted}
        $large={large}
        $small={small}
        className={className}
        style={style}
        {...otherProps}
      >
        {text}
      </DisplayWrapper>
    )
  }
}
